<template>
  <div class="skeleton-root">
    <div v-if="variant === 'slider'" class="skeleton w-full h-full">
      <USkeleton class="w-full h-full rounded-[24px] p-8">
        <div class="flex gap-2 opacity-30 mb-5">
          <USkeleton class="w-95 h-104 rounded-[24px] p-8 border">
            <div class="flex gap-2">
              <USkeleton class="w-23.25 h-7 border" />
              <USkeleton class="w-23.25 h-7 border" />
            </div>
          </USkeleton>
        </div>
      </USkeleton>
    </div>

    <template v-if="variant === 'card'">
      <USkeleton
        v-for="(_, index) in amount || 1"
        :key="index"
        class="w-103 h-114 rounded-[20px]"
        :class="[
          {
            'border-2 border-gray-200': border,
          },
          ui?.card,
        ]"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  variant?: 'slider' | 'card'
  amount?: number
  border?: boolean
  ui?: {
    card?: string
  }
}>()
</script>
